import { useAnalytics } from "~/components/Analytics";
import { Body, Link } from "~/ui-library";

type TabProps = {
  label: string;
  href: string;
};

export const LandingPageTabbedNavigationTab = ({ href, label }: TabProps) => {
  const { analyticsEnhancedTrack } = useAnalytics();

  const onClickHandler = () => {
    analyticsEnhancedTrack("Tabbed navigation clicked", {
      tabName: label,
    });
  };

  return (
    <Body as="li" bold>
      <Link
        aria-label={`Go to ${label}`}
        className="whitespace-nowrap"
        href={href}
        onClick={onClickHandler}
      >
        {label}
      </Link>
    </Body>
  );
};
